import React, { useEffect, memo, useState } from "react";
import Head from "next/head";
import Faq from "../../components/events/Faqs";
import Mentors from "../../components/events/Mentors";
import HeroBanner from "../../components/events/EventsHero";
import BottomBanner from "../../components/events/BottomBanner";
import ImageTestimonials from "../../components/events/ImageTestimonials";
import { pagedata as pageDataNew } from "../../data/connect/be-the-panel";
import { BASE_URL } from "../../constants";

// Utility function to check if an object is empty
const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0;
};

const BeThePanel = memo(() => {
    const [pagedata, setPageData] = useState(pageDataNew);
    return (
        <React.Fragment>
            {/* <SimpleBanner /> */}
            <main>
                <div id="single-events">
                    <HeroBanner
                        data={pagedata.heroData}
                        theme={pagedata.theme}
                        slug={pagedata.slug}
                    />
                </div>
                {!isEmptyObject(pagedata.heroData?.eventDetails) && (
                    <BottomBanner
                        data={pagedata.heroData.eventDetails}
                        theme={pagedata.theme}
                        slug={pagedata.slug}
                    />
                )}
                {!isEmptyObject(pagedata.mentors) && (
                    <Mentors data={pagedata.mentors} theme={pagedata.theme} />
                )}
                {!isEmptyObject(pagedata.imagetestimonials) && (
                    <ImageTestimonials
                        data={pagedata.imagetestimonials}
                        theme={pagedata.theme}
                    />
                )}
                {!isEmptyObject(pagedata.faqs) && (
                    <Faq data={pagedata.faqs} theme={pagedata.theme} />
                )}
            </main>
        </React.Fragment>
    )
});

export default BeThePanel;

export async function getStaticProps() {
    return {
        props: {
            meta: {
                title: "RAS 2023 - Be The Panel",
                description: "Join 'Be The Panel' – A unique interview practice program where students take turns as panelists. Reserve your slot now!",
                image: "https://toppersnotes-videos.b-cdn.net/webinars-programs/be-the-panel/ezgif.com-jpg-to-webp-converter.webp",
                url: `${BASE_URL}/connect/be-the-panel`
            }
        }
    };
}
